/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Accédez aux ressources et aux documents de support pour CamAPS FX et CamAPS Liberty®.',
    keywords: 'bibliothèque camaps, camaps fx, camaps liberty, ressources de support, gestion du diabète',
    localeMeta: 'fr_fr',

    bannerTitle: 'Support au-delà des chiffres',
    bannerSubtitle: 'avec CamAPS Liberty<sup>®</sup>',
    bannerDescription: "Lorsqu'il est activé, les utilisateurs n'auront pas besoin de compter les glucides et d'administrer un bolus d'insuline pré-repas.",
    bannerCompatibility: 'Compatible Android et iOS',
    
    announcementText: 'Bientôt disponible pour les utilisateurs Dana CamAPS FX et myLoop*',
    announcementDisclaimer: '* Sous réserve d\'approbations locales et de disponibilité',

    introTitle: 'La première fonction en boucle entièrement fermée. Quand vous en avez besoin.',
    introDescription: 'Lorsqu\'il est activé, les utilisateurs n\'auront pas besoin de compter les glucides et d\'administrer un bolus d\'insuline pré-repas.',
    introSubtext: 'Disponible sur les systèmes d\'exploitation Android et Apple',

    howItWorksTitle: 'Comment ça marche?',
    howItWorksDescription: 'Alimenté par une version plus proactive de l\'algorithme CamAPS. CamAPS Liberty anticipe et répond aux changements de glucose tout en maintenant des limites de sécurité établies.',
    
    step1Title: 'ÉTAPE 1',
    step1Description: 'Depuis votre écran d\'accueil, accédez au menu des paramètres.',
    step2Title: 'ÉTAPE 2',
    step2Description: 'Faites défiler vers le bas et appuyez sur l\'interrupteur pour activer.',
    step3Title: 'ÉTAPE 3',
    step3Description: 'Lors de la première utilisation, vous devrez regarder notre vidéo explicative sur CamAPS Liberty.',
    step4Title: 'ÉTAPE 4',
    step4Description: 'Confirmez que vous n\'avez pas moins de 13 ans et que vous n\'êtes pas enceinte.',
    step5Title: 'ÉTAPE 5',
    step5Description: 'Appuyez à nouveau sur l\'interrupteur pour activer.',
    step6Title: 'ÉTAPE 6',
    step6Description: "C'est prêt. L'onglet CamAPS Liberty apparaîtra sur votre écran d'accueil<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Ne fonctionne que lorsque le \"Auto mode\" est activé",

    eligibilityTitle: 'Qui peut utiliser CamAPS Liberty?',
    eligibilityCriterion1: 'Utilisateurs existants atteints de diabète de type 1',
    eligibilityCriterion2: '13 ans et plus',
    eligibilityCriterion3: 'Enceinte',
    parentsCarersTitle: 'Qu\'en est-il des parents et des aidants ?',
    parentsCarersBlockTitle: 'Fonction « Blocage » :',
    parentsCarersBlockDescription: 'Pour éviter toute utilisation accidentelle',
    parentsCarersRemoteTitle: 'Surveillance à distance :',
    parentsCarersRemoteDescription: 'Companion, Glooko® et rapports PDF CamAPS sur 2 semaines',
    
    imageOverlayText: 'Conçu pour fonctionner aux côtés de votre plan de gestion du diabète actuel; pas pour le remplacer.',
    
    usingTitle: 'Utilisation de CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty est conçue pour supprimer la nécessité d’administrer systématiquement des bolus aux repas. Elle ne remplace pas les autres éléments du plan de prise en charge du diabète de l’utilisateur, notamment le suivi régulier avec l’équipe soignante en diabétologie.',
    
    usingLibertyTitle: 'Découvrir CamAPS Liberty en vidéo',
    usingLibertyDescription: 'Explorez des vidéos pour en savoir plus sur CamAPS Liberty et démarrer.',
    // latestVideoLabel removed
    moreVideosLabel: 'Plus de vidéos',
    factsheetDownloadText: 'Fiche d\'information CamAPS Liberty (pdf)',
    factsheetUrl: '#',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty : Premiers pas',
        description: 'Candice Ward explique comment configurer et commencer à utiliser CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/QAYy8dTXUUc',
            title: 'Conseils pratiques : CamAPS Liberty',
            duration: '01:49',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Présentation de CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'CamAPS Liberty – retours d\'utilisateurs',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/W-7cq3CQ7pg',
            title: 'La fonctionnalité CamAPS Liberty',
            duration: '03:16',
        }
    ],
    
    whatHappensNextTitle: 'Que se passe-t-il ensuite?',
    whatHappensNextText: 'Nous mènerons un pilote dans un seul marché dans les mois à venir. Restez à l\'écoute pour plus de détails.',
};

